import { call, put, takeLatest } from 'redux-saga/effects';
import { YieldOf } from 'types/utils';
import { fetchMasks, fetchedMasks, fetchMask, fetchedMask } from './actions';
import { logout } from '../api-auth/actions';
import getAPI from '../../api/iv-back';

type FetchMasksActionPayload = ReturnType<typeof fetchMasks>;
type FetchMaskActionPayload = ReturnType<typeof fetchMask>;

export function* getMasksSaga({ meta: { callback } }: FetchMasksActionPayload) {
  const { getMasks } = getAPI();
  const response: YieldOf<typeof getMasks> = yield call(getMasks);
  const { data = [], ok, problem, status } = response;
  if (status === 401 || status === 403) {
    yield put(logout());
  }
  if (ok) {
    yield put(fetchedMasks(data));
  } else {
    const error = problem || 'unknown';
    yield put(fetchedMasks(undefined, error));
  }

  if (callback) callback();
}

export function* getMaskSaga({ meta: { situationId, callback } }: FetchMaskActionPayload) {
  const { getMask } = getAPI();
  const response: YieldOf<typeof getMask> = yield call(getMask, situationId);
  const { data, ok, problem, status } = response;
  if (status === 401 || status === 403) {
    yield put(logout());
  }
  if (ok) {
    yield put(fetchedMask(data));
  } else {
    const error = problem || 'unknown';
    yield put(fetchedMask(undefined, error));
  }

  if (callback) callback();
}

export default function* masksSaga() {
  yield takeLatest(fetchMasks.type, getMasksSaga);
  yield takeLatest(fetchMask.type, getMaskSaga);
}
